module.exports = __webpack_public_path__ + "files/ce2914f9d433fc1ef225e315d3f44b4b.png";


//////////////////
// WEBPACK FOOTER
// ./images/favicon/apple-touch-icon-57x57.png
// module id = 741
// module chunks = 27